import VATInfo from "../../steps/fragments/VATInfo";
import EndUserDetails from "./EndUserDetails";
import MedicalConditionsFragment from "./MedicalConditionsFragment";
import VATCheck from "./VATCheck";

function VatForm() {

  return (
    <div className="toggle-container">
      <div className='checkbox-and-input'>
        <div style={{ margin: '20px 0' }}>
          <VATInfo />
        </div>
        <div style={{ margin: '20px 0' }}>
          <VATCheck />
        </div>
        <div style={{ margin: '20px 0' }}>
          <EndUserDetails />
        </div>
        <div className='form-line'>
          <MedicalConditionsFragment />
        </div>
      </div>
    </div>
  );
}

export default VatForm;